import { useState } from "react";
import { Divider, Grid, Icon, IconButton } from "@mui/material";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import Drawer from "ui-components/Drawer";
import {
  getManifestLog,
  editManifestCarrier,
  editManifestTSmallCarton,
} from "services/data.outbound.service";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Fieldset, SelectFields, Texts } from "ui-components/Form";
import { getCarrierList } from "services/data.internal.service";
import { LoadingDialog } from "ui-components/Alert";

const columns = [
  { label: "DO Number", id: "doNumber" },
  { label: "Order Number", id: "orderNumber" },
  { label: "Cust Ord Nbr", id: "custOrdNbr" },
  { label: "Total Carton", id: "totalCarton" },
];

function LoadManifestLog({ open, setOpen, logRequest, setLogRequest }) {
  //const [logs, setLogs] = useState(null);
  const [edit, setEdit] = useState(false);
  const [editInfo, setEditInfo] = useState({ carrier: null });
  const queryClient = useQueryClient();

  const { data: manifest } = useQuery({
    queryKey: ["manifest-log", { logRequest }],
    queryFn: () => getManifestLog(logRequest),
    enabled: Boolean(logRequest),
    // onSuccess: (data) => {
    //   console.log(data.data.data);
    //   const item = data.data.data;

    //   const renderTimelineItems = item.logs.map(({ id, ...log }) => (
    //     <TimelineItem key={id} {...log} />
    //   ));
    //   setLogs(
    //     <>
    //       <div style={{ fontSize: "14px", marginBottom: "20px" }}>
    //         <Grid container>
    //           <Grid item xs={6}>
    //             <b>Manifest Number : </b>
    //             {item.manifestNumber}
    //           </Grid>
    //           <Grid item xs={6}>
    //             <b>Carrier : </b>
    //             {item.carrier}
    //           </Grid>
    //           <Grid item xs={6}>
    //             <b>Truck No : </b>
    //             {item.truckNo}
    //           </Grid>
    //           <Grid item xs={6}>
    //             <b>Transport Arrangement : </b>
    //             {item.transportArrangement}
    //           </Grid>
    //           <Grid item xs={6}>
    //             <b>Loading Datetime : </b>
    //             {item.loadingDatetime}
    //           </Grid>
    //         </Grid>
    //       </div>
    //       <div>
    //         <StickyHeadTable columns={columns} rows={item.details} />
    //       </div>
    //       <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
    //     </>
    //   );
    // },
  });

  const { data: carrierData } = useQuery({
    queryKey: ["carrier-options"],
    queryFn: () => getCarrierList({ active: true }),
    enabled: Boolean(logRequest) && logRequest.status === "L",
  });

  const carriers = carrierData?.data.data.map((x) => x.carrierCode) ?? [];

  const item = manifest?.data.data;

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    //setLogs(null);
    setEditingDetailId(null);
    setCarton("");
    setLogRequest(null);
  };

  const canEdit = edit;

  const editMutation = useMutation(editManifestCarrier, {
    onSuccess: () => {
      queryClient.invalidateQueries(["manifest-log"]);
      setEdit(false);
      setEditInfo({ carrier: null });
    },
  });
  const onSubmit = () => {
    editMutation.mutate({
      manifestId: logRequest.manifestId,
      ...editInfo,
    });
  };

  const [editingDetailId, setEditingDetailId] = useState(null);
  const [carton, setCarton] = useState("");

  const cartonMutation = useMutation(editManifestTSmallCarton, {
    onSuccess: () => {
      queryClient.invalidateQueries(["manifest-log"]);
      setEditingDetailId(null);
      setCarton("");
    },
  });
  const onSubmitCarton = () => {
    cartonMutation.mutate({
      manifestDetailsId: editingDetailId,
      tSmallCarton: Number(carton),
    });
  };
  const cartonValid = carton !== "" && /^\d+$/.test(carton);

  const editStatus = editMutation.status === "loading" || cartonMutation.status === "loading";

  // Only a LOADED manifest, and its LOADED detail rows, can be edited.
  const canEditCarton = Boolean(logRequest) && logRequest.status === "L";

  const detailRows = item?.details.map((x) => ({
    ...x,
    totalCarton:
      editingDetailId === x.manifestDetailsId ? (
        <Grid container spacing={1} alignItems="center" wrap="nowrap">
          <Grid item xs={4}>
            <Texts
              field={{ name: "", label: "", value: carton, errors: {} }}
              onChange={(e) => setCarton(e.target.value)}
            />
          </Grid>
          <Grid item>
            <MDButton color="info" size="small" onClick={onSubmitCarton} disabled={!cartonValid}>
              Submit
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              color="secondary"
              size="small"
              onClick={() => {
                setEditingDetailId(null);
                setCarton("");
              }}
            >
              Cancel
            </MDButton>
          </Grid>
        </Grid>
      ) : (
        <>
          {x.tSmallCarton}
          {canEditCarton && x.status === "L" && (
            <IconButton
              sx={{ width: "1rem", height: "1rem", ml: 1 }}
              color="success"
              onClick={() => {
                setCarton(x.tSmallCarton ?? "");
                setEditingDetailId(x.manifestDetailsId);
              }}
            >
              <Icon>edit</Icon>
            </IconButton>
          )}
        </>
      ),
  }));

  return (
    <Drawer open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {/* {logs} */}
      {editStatus && <LoadingDialog />}
      <MDTypography variant="h5" color="info">
        Load Manifest
        {Boolean(logRequest) && logRequest.status === "L" && (
          <IconButton
            sx={{ width: "1rem", height: "1rem", ml: 1 }}
            color="success"
            onClick={() => {
              setEdit(true);
            }}
          >
            <Icon>edit</Icon>
          </IconButton>
        )}
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(item) && (
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Manifest Number : </b>
                {item.manifestNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Carrier : </b>
                {item.carrier}
              </Grid>
              <Grid item xs={6}>
                <b>Truck No : </b>
                {item.truckNo}
              </Grid>
              <Grid item xs={6}>
                <b>Transport Arrangement : </b>
                {item.transportArrangement}
              </Grid>
              <Grid item xs={6}>
                <b>Loading Datetime : </b>
                {item.loadingDatetime}
              </Grid>
            </Grid>
            {canEdit && (
              <>
                <Fieldset label="Edit">
                  <Grid container spacing={1}>
                    <Grid item xs={2}>
                      <SelectFields
                        field={{ name: "", label: "Carrier", value: editInfo?.carrier, errors: {} }}
                        options={carriers}
                        onChange={(e, value) =>
                          setEditInfo((prev) => ({ ...prev, carrier: value }))
                        }
                      />
                    </Grid>
                    <Grid sx={{ marginLeft: "1rem" }} item xs={3}>
                      <MDButton
                        color="info"
                        onClick={onSubmit}
                        disabled={!Boolean(editInfo?.carrier)}
                      >
                        Submit
                      </MDButton>
                    </Grid>
                  </Grid>
                </Fieldset>
                {/* <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} /> */}
              </>
            )}
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={detailRows} />
          </div>
          <TimelineList title="Logs">
            {item.logs.map(({ id, ...log }) => (
              <TimelineItem key={id} {...log} />
            ))}
          </TimelineList>
        </>
      )}
    </Drawer>
  );
}

export default LoadManifestLog;
